import FormattedMessage from 'I18n/components/FormattedMessage';
import * as links from '../../lib/links';
import PortalIdParser from 'PortalIdParser';
import ViralTrackingPixel from 'viral-links-lib/viral-tracking/ViralTrackingPixel';
import { Button } from 'foundations-components/transitional/components/Button';
import { Flex } from 'foundations-components/components/Flex';
import { Link } from 'foundations-components/transitional/components/Link';
import { Logo } from 'foundations-components/transitional/components/Logo';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function UTMBanner() {
  const portalId = PortalIdParser.get();
  return /*#__PURE__*/_jsx(View, {
    position: "fixed",
    insetBlockEnd: "0",
    insetInlineStart: "0",
    insetInlineEnd: "0",
    paddingInline: "600",
    paddingBlock: "400",
    zIndex: 100,
    backgroundColor: "fill-surface-default",
    borderBlockStartWidth: "100",
    borderBlockStartStyle: "solid",
    borderBlockStartColor: "border-core-subtle",
    boxShadow: "100",
    children: /*#__PURE__*/_jsxs(Flex, {
      alignItems: "center",
      justifyContent: "space-between",
      children: [/*#__PURE__*/_jsx(Flex, {
        children: /*#__PURE__*/_jsxs(Link, {
          use: "unstyled",
          href: links.getSignupUrl(),
          external: true,
          rel: "nofollow noopener",
          children: [/*#__PURE__*/_jsx(FormattedMessage, {
            message: "view.utm.shareYourFiles"
          }), /*#__PURE__*/_jsx(Logo, {
            name: "hubspot-wordmark",
            width: "60px",
            alt: 'HubSpot',
            marginInline: "100",
            insetBlockStart: "100",
            position: "relative"
          })]
        })
      }), /*#__PURE__*/_jsxs(Button, {
        use: "primary",
        size: "small",
        href: links.getSignupUrl(),
        target: "_blank",
        rel: "nofollow noopener",
        children: [/*#__PURE__*/_jsx(FormattedMessage, {
          message: "view.utm.getHubSpotFree"
        }), portalId && /*#__PURE__*/_jsx(ViralTrackingPixel, {
          portalId: portalId,
          viralLinkType: "documents"
        })]
      })]
    })
  });
}